import { Typography, Box, Avatar, Paper } from "@mui/material";
import "./NotificationPage.css";
import "./colors.css";
import quote from "../../assets/Blue-sidebar-icon/Quote.svg";
import contract from "../../assets/Blue-sidebar-icon/Contract.svg";
import customerIcon from "../../assets/Blue-sidebar-icon/Customer.svg";
import InvoiceIcon from "../../assets/Blue-sidebar-icon/Invoice.svg";
import ManageAccount from "../../assets/Blue-sidebar-icon/ManageAccount.svg";
import templetess from "../../assets/Blue-sidebar-icon/templetess.svg";
import RecurringCharge from "../../assets/Blue-sidebar-icon/RecurringCharge.svg";
import RecurrinPayment from "../../assets/Blue-sidebar-icon/RecurrinPayment.svg";
import signature from "../../assets/Blue-sidebar-icon/signature.svg";
import Visit from "../../assets/Blue-sidebar-icon/Visit.svg";
import CardPayment from "../../assets/Blue-sidebar-icon/CardPayment.svg";
import AchPayment from "../../assets/Blue-sidebar-icon/AchPayment.svg";
import CashPayment from "../../assets/Blue-sidebar-icon/CashPayment.svg";

import { useUserType } from "../../contexts/UserTypeContext";

const getIcon = (createdBy) => {
  if (createdBy?.includes("Quote")) return quote;
  if (createdBy?.includes("Contract")) return contract;
  if (createdBy?.includes("Invoice")) return InvoiceIcon;
  if (createdBy?.includes("Worker")) return customerIcon;
  if (createdBy?.includes("Visit")) return Visit;
  if (createdBy?.includes("Account")) return ManageAccount;
  if (createdBy?.includes("Template")) return templetess;
  if (createdBy?.includes("RecurringCharge")) return RecurringCharge;
  if (createdBy?.includes("RecurringPayment")) return RecurrinPayment;
  if (createdBy?.includes("Recurring Charge Payment")) return RecurringCharge;
  if (createdBy?.includes("SignatureRequest")) return signature;
  if (createdBy?.includes("ACHPayment")) return AchPayment;
  if (createdBy?.includes("CardPayment")) return CardPayment;
  if (createdBy?.includes("Company") || createdBy?.includes("Company-Signup") || createdBy?.includes("Company-Add")) return customerIcon;
  if (createdBy?.includes("CustomerMessage") || createdBy?.includes("Customer Message") || createdBy?.includes("Note")) return customerIcon;
  return CashPayment;
};

const formateDocumentType = (documentType) => {
  if (documentType === "MaterialsAndLabor") return "Materials & Labor";
  if (documentType === "RequestChange") return "Request Change";
  if (documentType === "SignatureRequest") return "Signature Request";
  if (documentType === "ACHPayment") return "ACH Payment";
  if (documentType === "CardPayment") return "Card Payment";
  if (documentType === "RecurringCharge") return "Recurring Charge";
  if (documentType === "Recurring-Charge") return "Recurring Charge";
  if (documentType === "RecurringChargePayment")
    return "Recurring Charge Payment";
  if (documentType === "RecurringPayment") return "Recurring Payment";
  if (documentType === "RecurringChargeInvoice")
    return "Recurring Charge Invoice";
  if (documentType === "CustomerMessage") return "Customer Event";
  if (documentType === "Note") return "Note";
  return documentType;
};

const NotificationCard = ({
  handleNotificationClick,
  style,
  isUnread,
  notificationData,
}) => {
  const amount =
    notificationData?.amount ||
    notificationData?.total ||
    notificationData?.paymentAmount;
  const userName = notificationData?.firstName || notificationData?.lastName
    ? `${notificationData?.firstName || ""} ${notificationData?.lastName || ""}`.trim()
    : "";
  const icon = getIcon(notificationData?.createdBy);
  const { userType } = useUserType();
  const isDonationMode = userType === "donor";

  const getPaymentIcon = () => {
    if (notificationData?.paymentMethod === "ACH") return AchPayment;
    if (notificationData?.paymentMethod === "Card") return CardPayment;
    if (notificationData?.paymentMethod === "Payment") return CashPayment;
    if (notificationData?.paymentMethod === "Recurring Charge Payment")
      return RecurringCharge;
    if (notificationData?.paymentMethod === "Recurring Payment")
      return RecurrinPayment;
    return CashPayment;
  };

  const getPaymentText = () => {
    if (notificationData?.documentType === "ACHPayment") return "ACH Payment";
    if (notificationData?.documentType === "CardPayment") return "Card Payment";
    if (notificationData?.documentType === "Payment") return "Payment";
    if (notificationData?.documentType === "RecurringChargePayment")
      return "Recurring Charge Payment";
    if (notificationData?.documentType === "RecurringPayment")
      return "Recurring Payment";
    if (notificationData?.documentType === "Recurring Payment")
      return "Recurring Payment";
    return notificationData?.documentType;
  };
  const isUserCreationNotification = ["Customer", "Worker", "Donor", "Company"].includes(
    notificationData?.documentType
  );

  const isPaymentNotification = [
    "ACHPayment",
    "CardPayment",
    "Payment",
    "RecurringChargePayment",
    "Recurring Payment",
  ].includes(notificationData?.documentType);

  const isDocumentNotification = [
    "Quote",
    "Contract",
    "Invoice",
    "SignatureRequest",
    "Visit",
  ].includes(notificationData?.documentType);

  const isOtherNotification = [
    "MaterialsAndLabor",
    "Note",
    "CustomerMessage",
    "RequestChange",
    "Template",
    "Account",
    "RecurringPayment",
  ].includes(notificationData?.documentType);

  const isPaymentFailedNotification =
    notificationData?.paymentStatus === "Failed";

  let borderColor = isDonationMode ? "#66D59A" : "#D4943A";
  borderColor = isPaymentFailedNotification ? "#FF0000" : borderColor;
  const message = notificationData?.message;

  const isNotFormatedDocumentType = [
    "MaterialsAndLabor",
    "RequestChange",
    "RecurringChargePayment",
    "RecurringPayment",
    "SignatureRequest",
    "ACHPayment",
    "CardPayment",
    "CashPayment",
    "RecurringCharge",
    "Recurring-Charge",
    "RecurringChargeInvoice",
    "CustomerMessage",
    "Note",
  ].includes(notificationData?.documentType);

  const notificationTypeText = isNotFormatedDocumentType
    ? formateDocumentType(notificationData?.documentType)
    : notificationData?.documentType;

  const customerOrDonorLabel = isDonationMode ? "Donor" : "Customer";

  return (
    <Paper
      className="notification-feed-card"
      onClick={handleNotificationClick}
      elevation={0}
      sx={{
        position: "relative",
        width: "100%",
        maxWidth: {
          xs: "100%",
          sm: "100%",
          md: "400px",
        },
        margin: "0 auto 0px auto",
        padding: {
          xs: "8px 8px 4px 8px",
          sm: "12px 12px 6px 12px",
          md: "16px 16px 8px 16px",
        },
        "& > div": {
          border: `2px solid ${isUnread ? borderColor : ""}`,
          borderRadius: "12px",
          overflow: "hidden",
          backgroundColor: "white",
          boxShadow: "none",
          transition: "all 0.3s ease",
          cursor: "pointer",
          opacity: isUnread ? 1 : 0.7,
        },
      }}
    >
      <Box>
        <Box sx={{ position: "relative", padding: "16px" }}>
          {isUnread && (
            <Box
              sx={{
                position: "absolute",
                top: "16px",
                left: "16px",
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                backgroundColor: isDonationMode ? "#66D59A" : "#D4943A",
              }}
            />
          )}

          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              gap: { xs: "8px", sm: "10px", md: "12px" },
              marginBottom: { xs: "6px", sm: "7px", md: "8px" },
            }}
          >
            <Avatar
              sx={{
                width: { xs: 40, sm: 44, md: 48 },
                height: { xs: 40, sm: 44, md: 48 },
                ...(!isDonationMode && {
                  border: "2px solid #D4943A",
                }),
              }}
              className={
                isDonationMode
                  ? "border-donor-color bg-donor-color"
                  : "bg-blue-color"
              }
            >
              <Box
                component="img"
                src={isPaymentNotification ? getPaymentIcon() : icon}
                alt={notificationTypeText || "notification"}
                sx={{
                  width: { xs: "20px", sm: "22px", md: "24px" },
                  height: { xs: "20px", sm: "22px", md: "24px" },
                  filter: "brightness(0) invert(1)",
                }}
              />
            </Avatar>

            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      marginBottom: "4px",
                    }}
                  >
                    <Typography
                      className="text-blue-color"
                      sx={{
                        fontSize: {
                          xs: "0.75rem",
                          sm: "0.8125rem",
                          md: "0.875rem",
                        },
                        fontWeight: 500,
                      }}
                    >
                      {message}
                    </Typography>
                  </Box>
                </Box>

                {amount && !isPaymentNotification && (
                  <Box
                    className="text-white-color"
                    sx={{
                      fontWeight: 700,
                      fontSize: {
                        xs: "0.75rem",
                        sm: "0.8125rem",
                        md: "0.875rem",
                      },
                      padding: {
                        xs: "3px 10px",
                        sm: "3px 11px",
                        md: "4px 12px",
                      },
                      borderRadius: "20px",
                      marginLeft: "12px",
                      backgroundColor: isDonationMode ? "#66D59A" : "#D4943A",
                    }}
                  >
                    ${Number(amount).toLocaleString("en-US")}
                  </Box>
                )}
                {isPaymentNotification && notificationData?.paymentAmount && (
                  <Box
                    className="text-white-color"
                    sx={{
                      fontWeight: 700,
                      fontSize: {
                        xs: "0.75rem",
                        sm: "0.8125rem",
                        md: "0.875rem",
                      },
                      padding: {
                        xs: "3px 10px",
                        sm: "3px 11px",
                        md: "4px 12px",
                      },
                      borderRadius: "20px",
                      marginLeft: "12px",
                      backgroundColor: isPaymentFailedNotification
                        ? "#d32f2f"
                        : isDonationMode
                          ? "#66D59A"
                          : "#D4943A",
                    }}
                  >
                    ${Number(notificationData?.paymentAmount).toLocaleString("en-US")}
                  </Box>
                )}
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              position: "relative",
              marginLeft: { xs: "-8px", sm: "-12px", md: "-16px" },
              marginRight: { xs: "-8px", sm: "-12px", md: "-16px" },
              marginTop: { xs: "6px", sm: "7px", md: "8px" },
            }}
          >
            <Box
              className={
                isUnread
                  ? isDonationMode
                    ? "bg-white-donor-color"
                    : "light-gray-bg"
                  : "gray-bg"
              }
              sx={{
                padding: { xs: "12px", sm: "14px", md: "16px" },
                position: "relative",
                paddingBottom: { xs: "32px", sm: "36px", md: "40px" },
              }}
            >
              <Typography
                className={
                  isDonationMode ? "text-donor-color" : "text-blue-color"
                }
                sx={{
                  fontWeight: 600,
                  fontSize: { xs: "0.75rem", sm: "0.8125rem", md: "0.875rem" },
                  marginBottom: { xs: "8px", sm: "10px", md: "12px" },
                }}
              >
                {isPaymentNotification &&
                  !isUserCreationNotification &&
                  getPaymentText()}
                {!isPaymentNotification &&
                  !isUserCreationNotification &&
                  `${notificationTypeText}`}
                {!isPaymentNotification &&
                  isDocumentNotification &&
                  `#${notificationData?.documentNumber}`}
              </Typography>

              <Box sx={{ display: "flex", gap: "12px" }}>
                <Box
                  sx={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                    marginBottom: { xs: "4px", sm: "6px", md: "8px" },
                  }}
                >
                  <Typography
                    className="text-gray"
                    sx={{
                      fontSize: {
                        xs: "0.75rem",
                        sm: "0.8125rem",
                        md: "0.875rem",
                      },
                      fontWeight: 500,
                      wordBreak: "break-word",
                    }}
                  >
                    {isPaymentNotification && !isUserCreationNotification && (
                      <>
                        Payment Status:{" "}
                        {(notificationData?.paymentStatus || "Completed")
                          .toLowerCase()
                          .replace(/^\w/, (c) => c.toUpperCase())}
                      </>
                    )}
                  
                    {!isPaymentNotification && isUserCreationNotification && (
                      <>Title : User Created</>
                    )}
                    {!isPaymentNotification && isDocumentNotification && (
                      <>Title : {notificationData?.title}</>
                    )}
                    {!isPaymentNotification &&
                      isOtherNotification &&
                      notificationData?.name &&
                      notificationData?.type && (
                        <>
                          <>Name : {notificationData?.name}</>
                          <br />
                          <>Type : {notificationData?.type}</>
                        </>
                      )}
                  </Typography>
                  <Typography
                    className="text-gray"
                    sx={{
                      fontSize: {
                        xs: "0.75rem",
                        sm: "0.8125rem",
                        md: "0.875rem",
                      },
                      wordBreak: "break-word",
                    }}
                  >
                    {isPaymentNotification && !isUserCreationNotification && (
                      <>
                        <>Method : {notificationData.paymentMethod || "N/A"}</>
                        <br />
                        <>
                          Transaction ID:{" "}
                          {notificationData?.paymentTransactionId || "N/A"}
                        </>
                        <br />
                      </>
                    )}
                    {!isPaymentNotification &&
                      !isUserCreationNotification &&
                      notificationData?.firstName && (
                        <>
                          {customerOrDonorLabel}: {userName}
                        </>
                      )}
                    {!isPaymentNotification && isUserCreationNotification && (
                      <>
                        {notificationData?.documentType === "Company" ? (
                          <>
                            Company: {notificationData?.companyName || "New Company"}
                            {notificationData?.companyEmail && (
                              <>
                                <br />
                                Email: {notificationData?.companyEmail}
                              </>
                            )}
                          </>
                        ) : (
                          <>
                            {notificationTypeText}: {userName}
                          </>
                        )}
                      </>
                    )}
                  </Typography>
                </Box>
              </Box>

              <Typography
                className="text-gray"
                sx={{
                  position: "absolute",
                  bottom: { xs: "8px", sm: "10px", md: "12px" },
                  right: { xs: "12px", sm: "14px", md: "16px" },
                  fontSize: { xs: "0.625rem", sm: "0.6875rem", md: "0.75rem" },
                }}
              >
                {notificationData?.formattedTime || ""}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Paper>
  );
};

export default NotificationCard;
